export interface IServiceObject<T> {
  code: number
  data: T
  datas?: T
  extra?: any
  message?: string
}
export enum LocalesDataEnum {
  'zh' = 'zh',
  'en' = 'en',
  'vi' = 'vn',
  'zh-tw' = 'tw',
  'es' = 'es',
  'ru' = 'ru',
  'fr' = 'fr',
  'de' = 'de',
  'pt' = 'pt',
  'th' = 'th',
  'id' = 'id',
  'tr' = 'tr',
  'ja' = 'ja',
  'ar' = 'ar',
  'uk' = 'uk',
  'pt-br' = 'br',
  'nl' = 'nl',
  'it' = 'it',
  'en-eu' = 'en-eu',
  'it-eu' = 'it-eu',
}

export const LocalesDataMap = {
  [LocalesDataEnum.zh]: 'cn',
  [LocalesDataEnum.en]: 'en',
  [LocalesDataEnum.vi]: 'vn',
  [LocalesDataEnum['zh-tw']]: 'tw',
  [LocalesDataEnum.es]: 'es',
  [LocalesDataEnum.ru]: 'ru',
  [LocalesDataEnum.fr]: 'fr',
  [LocalesDataEnum.de]: 'de',
  [LocalesDataEnum.pt]: 'pt',
  [LocalesDataEnum.th]: 'th',
  [LocalesDataEnum.id]: 'id',
  [LocalesDataEnum.tr]: 'tr',
  [LocalesDataEnum.ja]: 'ja',
  [LocalesDataEnum.ar]: 'ar',
  [LocalesDataEnum.uk]: 'uk',
  [LocalesDataEnum['pt-br']]: 'br',
  [LocalesDataEnum.nl]: 'nl',
  [LocalesDataEnum.it]: 'it',
  ['zh-tw']: 'tw',
  ['pt-br']: 'br',
  vi: 'vn',
  [LocalesDataEnum['en-eu']]: 'en-eu',
  [LocalesDataEnum['it-eu']]: 'it-eu',
}

export const DayjsLocaleMap = {
  [LocalesDataEnum.zh]: 'zh',
  [LocalesDataEnum.en]: 'en',
  [LocalesDataEnum.vi]: 'vi',
  [LocalesDataEnum['zh-tw']]: 'zh-tw',
  [LocalesDataEnum.es]: 'es',
  [LocalesDataEnum.ru]: 'ru',
  [LocalesDataEnum.fr]: 'fr',
  [LocalesDataEnum.de]: 'de',
  [LocalesDataEnum.pt]: 'pt',
  [LocalesDataEnum.th]: 'th',
  [LocalesDataEnum.id]: 'id',
  [LocalesDataEnum.tr]: 'tr',
  [LocalesDataEnum.ja]: 'ja',
  [LocalesDataEnum.ar]: 'ar',
  [LocalesDataEnum.uk]: 'uk',
  [LocalesDataEnum['pt-br']]: 'pt-br',
  [LocalesDataEnum.nl]: 'nl',
  [LocalesDataEnum.it]: 'it',
  [LocalesDataEnum['en-eu']]: 'en-eu',
  [LocalesDataEnum['it-eu']]: 'it-eu',
}

/**
 * web端使用的cookie lang对应的local内容
 */
export const webLangToLocalesDataMap = {
  cn: 'zh',
  en: 'en',
  vn: 'vi',
  tw: 'zh-tw',
  es: 'es',
  ru: 'ru',
  fr: 'fr',
  de: 'de',
  pt: 'pt',
  th: 'th',
  id: 'id',
  tr: 'tr',
  ja: 'ja',
  ar: 'ar',
  uk: 'uk',
  br: 'pt-br',
  nl: 'nl',
  it: 'it',
  'en-eu': 'en-eu',
  'it-eu': 'it-eu',
}
/**
 * webLangToLocalesDataMap 的key类型
 */
export type webLangToLocalesDataType = keyof typeof webLangToLocalesDataMap

/**
 * 安卓app端使用时，对应的语言信息
 */
export const androidLocalesDataMap = {
  cn: 'zh',
  en: 'en',
  vi: 'vi',
  tw: 'zh-tw',
  es: 'es',
  ru: 'ru',
  fr: 'fr',
  de: 'de',
  pt: 'pt',
  th: 'th',
  in: 'id',
  tr: 'tr',
  ja: 'ja',
  ar: 'ar',
  uk: 'uk',
  br: 'pt-br',
}

export type androidLocalesDataType = keyof typeof androidLocalesDataMap

/**
 * ios app端使用时，对应的语言信息
 */
export const iosLocalesDataMap = {
  cn: 'zh',
  en: 'en',
  vi: 'vi',
  tw: 'zh-tw',
  es: 'es',
  ru: 'ru',
  fr: 'fr',
  de: 'de',
  th: 'th',
  tr: 'tr',
  ja: 'ja',
  ar: 'ar',
  uk: 'uk',
  'pt-BR': 'pt-br',
  'pt-PT': 'pt',
  id: 'id',
}

export type iosLocalesDataType = keyof typeof iosLocalesDataMap

export interface HeaderMenuType {
  code: string
  name?: string
  icon?: string
  path?: string
  hidden: boolean
  child?: HeaderMenuType[]
}

export enum RiseColorEnum {
  'risered' = 'red',
  'risegreen' = 'green',
}

export interface HeaderSettingData {
  lang_list: Record<string, string>
  fiat_list: Record<string, FiatListItem>
  is_service_host: boolean
  curr_fiat: string
  currency_count: string
  curr_fiat_market_rates: Record<string, string>
  defaultBuyCryptoFiat: string
  defaultP2PFiat: string
}

export interface HeaderCheckData {
  business: string[]
  limit: {
    [k: string]: any
  }
  toast: {
    [k: string]: any
  }
  menu: string[]
}

export interface FiatListItem {
  fiat: string
  precision: number
  symbol: string
}

// 合规
export interface IHeaderServerCompliance {
  isUKLimit: boolean
  isBrazilToast: boolean
  isNlLimit: boolean
  isHKUser: boolean
  isItalyLimit: boolean
  isLTWToast: boolean
  isUzbekistanToast: boolean
  isWithdrawOnlyUser: boolean
  kyc_toast: IKYCToast
  limitCountryUserStatus: string
  isShowComplianceTips: boolean
  isBlockedCountry: boolean
}

// commonData
export interface IHeaderCommonData extends IHeaderServerCompliance {
  fiat_list: {
    [key: string]: FiatListItem
  }
  lang_list: {
    [key: string]: string
  }
  lang_prefix: string
  sub_website_id: number
  is_service_host: boolean
  curr_fiat: string
  currency_count: string
  defaultBuyCryptoFiat: string
  defaultP2PFiat: string
  curr_fiat_market_rates: {
    [key: string]: string
  }
  // 可选
  is_login?: boolean
  device_type?: string
  appLang?: string
  market_rise_color?: string
  is_float_rate?: number
  isLogin?: boolean
  lang_code?: string
  is_phone?: boolean
  is_cn?: boolean
  is_tw?: boolean
  is_en?: boolean
  is_copper?: number
}

// 将某部分属性转成可选的
export type PartialPropsOption<T, K extends keyof T> = Partial<Pick<T, K>> & Omit<T, K>

export interface IKYCToast {
  is_risk_user?: string
  risk_user_guide_url?: string
  risk_user_guide_msg?: string
  risk_user_guide_cookie_key?: string
  risk_user_guide_be_closed?: number
  risk_user_guide_frequency?: number
  show_kyc_upgrade_notice?: number
}

export interface TextLink {
  key: string
  link: string
}

export interface BusinessCheckData {
  content: string
  title?: string
  ok_button?: string
  cancel_button?: string
  ok_button_router?: string
  no_close_button?: boolean
  text_link?: {
    key: string
    link: string
  }[]
}

export interface IIndexDBCache<T> {
  id: number
  key: string
  tags: string
  timest: number
  value: T
}
